export default __webpack_public_path__ + "static/media/codechef.42aeaad6.png";